export class MigrerDossier
{
    processInstanceId:String;
    requestId:String;
    taskId:String;
    
    toProcessDefinitionKey:String;
    toProcessDefinitionVersion:number;
    cancelActivityId:String;
    startActivityId:String;
    
    commentaire:String;
}